<template>
  <div>
    <div style="display:flex; justify-content: center;">
      <div class="f-ticket">
        <div class="f-ticket__decor" :style="{background: item.color || 'rgba(0,0,0,0.1)'}"></div>
        <div class="f-ticket__qr">
          <div class="f-ticket__qr_imgs" >
            <div style="height: 35px;">
              <img
                v-if="!metadata.hiddenlogojoinnus && !metadata.hiddenlogojoinnus.qr"
                style="height: 100%; max-width: 100%"
                :src="metadata.logoHeadQr ||  'https://s3.us-west-2.amazonaws.com/joinnus.com/files/joinnus-com-logo.svg'" alt="jn"
              >
            </div>
            <div class="f-ticket__qr_qr" style="margin-top: 10px;">
              <img width="95" :src="'https://qr.joinnus.com/qr.png?size=130&body=' + item.code" alt="qr">
              <span style="font-size: 10px;">{{ item.code }}</span>
            </div>
          </div>
          <div class="f-ticket__qr_title">
            {{(item.activityTitle).substring(0, 26)}}
          </div>
          <div class="f-ticket__qr_vs">
            <div><b>{{item.address}}</b></div>
            {{ itemDate }}
          </div>
          <div class="f-ticket__qr_tribuna">
            <div>
              <small>Tipo de entrada</small>
              <div class="tribune">{{ item.tribuna }}</div>
            </div>
            <div v-if="!item.hiddenPosition && item.position">
              <div><small>Asiento</small></div>
              <b style="font-size:8.5px;">{{ item.position }}</b>
            </div>
          </div>
          <div class="f-ticket__qr_sector">
          </div>
          <div class="f-ticket__qr_info">
            <b>*Recuerda</b>
            tu código QR es lo más importante de tu entrada Joinnus. No lo compartas con nadie.
          </div>
        </div>
        <div class="f-ticket__body">
          <span class="f-ticket__body_ruc">
            ORGANIZADO POR:
            <span v-if="metadata.ruc">{{ metadata.ruc }}</span>
            <template v-else>
              <span> {{ extra ? extra.OrgFirstName : '-' }} {{ extra ? extra.OrgLastName : '-' }}</span>
              <span v-if="extra && extra.OrgDniUser"> - {{ extra.OrgDniUser }}</span>
            </template>
          </span>
          <small class="f-ticket__body_sure">
            <div v-if="pulep">
              <small>
                <b>
                  CÓDIGO PULEP: {{ pulep.charValue }}
                </b>
              </small>
            </div>
            <div>* Conserve su ticket. {{ metadata.poliza }}</div>
            <div v-if="restrictionTicket">* {{ restrictionTicket }}</div>
          </small>
          <div class="f-ticket__body_content">
            <div class="f-ticket__body_head">
              <div class="f-ticket__body_date">
                <div class="ft-upper">
                  <b>{{item.addressRef}}</b>
                </div>
              </div>
            </div>
            <div class="f-ticket__body_vs">
              <div class="f-ticket-vs">
                <div class="f-ticket-vs__head">
                  <b>{{ metadata.tourney }}</b>
                </div>
                <div class="f-ticket-vs__body">
                  <div :class="{'f-ticket-vs__vs': true, 'f-ticket-activityLogo': metadata.activityLogo}">
                    <!-- <img :src="metadata.activityLogo" v-if="metadata.activityLogo"> -->
                    <object
                      :data="metadata.activityLogo"
                      style="width: 92px;"
                      v-if="metadata.activityLogo"
                    ></object>
                    <div style="text-align:center;">
                      {{item.activityTitle}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="f-ticket__body_tribune">
              <div style="max-width: 45%; width: 100%;">
                <div>
                  <div><b>{{ item.username }}</b></div>
                  <div v-if="item.document !== '00000000'">
                    {{ item.docType ? item.docType : 'DNI' }} <b>{{ item.document }}</b>
                  </div>
                </div>
              </div>
              <div class="ft-body-sector">
                <div
                  style="overflow: hidden;">
                  <b>{{item.tribuna}}</b>
                </div>
                <div v-if="!item.hiddenPosition && (item.sector || item.position)">
                  <span v-if="item.position">Asiento <b>{{ item.position }}</b></span>
                </div>
                <div>
                  <b>
                    {{ itemDate }}
                  </b>
                </div>
                <div>
                  <b>
                    <span v-if="item.turno">{{ item.turno }}</span>
                    <span v-else>{{ item.hour }}</span>
                  </b>
                  <span> </span>
                </div>
                <div v-if="item.precio >= 0">
                  <div v-if="item.precio > 0">
                    <b>
                      <span>{{ item.currency == 'PEN' ? 'S/' : '$' }} {{ item.precio }}</span>
                    </b>
                  </div>
                  <div v-else-if="item.paymentMethod === 'package'">
                    <span>Abono</span>
                  </div>
                  <div v-else>
                    <span>Cortesía</span>
                  </div>
                  <b> </b>
                </div>
              </div>
            </div>
            <div class="f-ticket__body_logos">
              <div>
                <img v-for="url in metadata.sponsors" :src="url" :key="url" height="21"  alt="jn">
              </div>
              <div style="height: 40px">
                <img
                  v-if="!metadata.hiddenlogojoinnus.body"
                  style="height: 100%;"
                  class="ft-jn"
                  src="https://s3.us-west-2.amazonaws.com/joinnus.com/files/joinnus-com-logo.svg"
                  alt="jn">
              </div>
            </div>
          </div>
        </div>
        <div class="f-ticket__info">
          <div class="f-ticket__info_body">
            <div class="f-ticket__info_tribuna">
              <div>
                <div>Tipo de entrada</div>
                <div class="tribunaLg">
                  <b>{{ item.tribuna }}</b>
                </div>
              </div>
              <div v-if="item.sector">
                <div>Sector</div>
                <div class="tribunaLg">{{ item.sector }}</div>
              </div>
              <div v-if="item.fila">
                <div>Fila</div>
                <div class="tribunaLg">{{ item.fila }}</div>
              </div>
              <div v-if="!item.hiddenPosition && item.asiento">
                <div>Asiento</div>
                <div class="tribunaLg">{{ item.asiento }}</div>
              </div>
            </div>
            <div class="f-ticket__info_footer">
              <div class="f-ticket__info_vs">
                <!-- <div><strong><?php $this->activity->title; ?></strong></div> -->
                <!-- <div><strong>{{(item.activityTitle).substring(0, 26)}}</strong></div> -->
                <div class="f-ticket__info_stadium">
                  {{ item.address }}
                  <span>
                    {{ itemDate }}
                  </span>
                </div>
              </div>
              <div class="f-ticket__info_price">
                <div v-if="item.precio > 0">
                  <small>Precio</small>
                  {{ metadata.currency }} {{ item.precio }}
                </div>
                <div v-if="item.precio === 0 || item.precio === '0.00'">
                  Cortesía
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="f-ticket__barcode">
          <div class="f-ticket__barcode_body">
            <div class="f-ticket__barcode_head">
              <div class="f-ticket__barcode_data">
                {{ item.username }}
                <br>
                <span v-if="item.document !== 'null' && item.document !== '00000000' && item.docType !== ''">
                  {{ item.docType ? item.docType : 'DNI' }}: {{ item.document }}
                </span>
                <span>&nbsp;</span>
              </div>
              <div class="f-ticket__barcode_price">
                <div v-if="item.precio > 0">
                  <small>Precio</small>
                  {{ metadata.currency }} {{ item.precio }}
                </div>
                <div v-if="item.precio === 0 || item.precio === '0.00'">
                  Cortesía
                </div>
              </div>
            </div>
            <div class="f-ticket__barcode_footer">
              <div>
                <small>Tipo de entrada</small>
                <small style="text-transform:uppercase;">{{ item.tribuna }}</small>
              </div>
              <div>
                <img :src="'https://www.joinnus.com/activity/ticket/' + (item.code_bar ? item.code_bar : item.code) + '/barcode?t=2&h=20'" alt="barcode1" height="20" width="130">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-detail no-print" v-if="detail">
        <div class="table-detail">
          <div>
            <div class="">
              <h5>
                <b>Detalle de la entrada</b>
              </h5>
            </div>
            <div>
              <div>
                <div class="row" style="display: flex; justify-content:space-between">
                  <span>Valor Neto Entrada</span>
                  <span>{{ item.currency == 'PEN' ? 'S/' : '$' }} {{((item.precio/1.298)*0.92).toFixed(2)}}</span>
                </div>
                <div class="row" style="display: flex; justify-content:space-between">
                  <span>Impuesto Municipal</span>
                  <span>{{ item.currency == 'PEN' ? 'S/' : '$' }} {{((item.precio/1.298)*0.1*0.92).toFixed(2)}}</span>
                </div>
                <div class="row" style="display: flex; justify-content:space-between; padding-bottom:5px">
                  <span>IGV(18%)</span>
                  <span>{{ item.currency == 'PEN' ? 'S/' : '$' }} {{((item.precio/1.298)*0.198*0.92).toFixed(2)}}</span>
                </div>
                <div class="row" style="display: flex; justify-content:space-between; border-top:1px solid #000">
                  <span>Total Entrada sin comisión</span>
                  <span>{{ item.currency == 'PEN' ? 'S/' : '$' }} {{(item.precio*0.92).toFixed(2)}}</span>
                </div>
                <div class="row" style="display: flex; justify-content:space-between; padding-bottom:5px">
                  <span>Comisión Joinnus(8%)</span>
                  <span>{{ item.currency == 'PEN' ? 'S/' : '$' }} {{(item.precio*0.08).toFixed(2)}}</span>
                </div>
                <div class="row" style="display: flex; justify-content:space-between; border-top:1px solid #000">
                  <span><b>Total</b></span>
                  <span><b>{{ item.currency == 'PEN' ? 'S/' : '$' }} {{(item.precio)}}</b></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const months = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Setiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
]

const days = [
  'Domingo',
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
]

const parseMetaLogoJoinnus = (metaValue) => {
  console.log(metaValue);
  if (!metaValue) return { qr: false, body: false };
  return {
    qr: ["all", "qr"].includes(metaValue),
    body: ["all", "body"].includes(metaValue),
  };
};

const getFieldMeta = (key, item) => {
  return item.metadata.find((el) => el.key === key) ? item.metadata.find((el) => el.key === key).charValue : ''
}

const generateMetadata = (item) => {
  const obj = {}

  if ( !item.metadata.length ) return obj

  obj.currency = item.currency === 'PEN' ? 'S/' : '$'
  obj.dateStart = `${item.day} ${months[item.month - 1]} ${item.year} - ${item.hour}`
  obj.stadium = item.addressRef
  obj.stadiumAddress = item.address

  obj.ruc = getFieldMeta('sport_ticket_ruc', item)
  obj.poliza = getFieldMeta('sport_ticket_policy', item)
  obj.tourney = getFieldMeta('sport_ticket_championship', item)
  obj.hiddenlogojoinnus = parseMetaLogoJoinnus(getFieldMeta("hiddenlogojoinnus", item));
  obj.logoHeadQr = getFieldMeta("logoHeadQr", item);
  obj.vs = getFieldMeta('sport_ticket_vs', item) && JSON.parse(getFieldMeta('sport_ticket_vs', item))
  obj.sponsors = getFieldMeta('sport_ticket_sponsors', item) && JSON.parse(getFieldMeta('sport_ticket_sponsors', item))
  obj.activityLogo = getFieldMeta('activity_logo', item)
  return obj
};

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    detail: {
      type: Object,
      required: false,
    },
    extra: {
      type: Object,
    },
    pulep: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    itemDate() {
      const item = this.item;
      return `${item.day < 10 ? (`0${item.day}`) : item.day} DE ${this.getFormatMonth(item.dateStart)} DEL ${item.year}`;
    },
    metadata () {
      console.log(this.item);
      console.log(generateMetadata(this.item));
      return generateMetadata(this.item)
    },
    restrictionTicket(){
      const meta = this.item.metadata.find((el) => el.key === "restrictionticket");
      return meta ? meta.charValue : null;
    },
    dateStartDay () {
      const dateRange = getFieldMeta('date_range', this.item);
      const dt = new Date(this.item.dateStart);
      const dateStartDay = `${days[dt.getDay()]}, ${this.item.day} ${months[this.item.month - 1]} ${this.item.year} - ${this.item.hour}`;
      return dateRange ? dateRange : dateStartDay;
    },
    dateRange () {
      const dateRange = getFieldMeta('date_range', this.item);
      return dateRange ? true : false;
    },
    seatsPrint () {
      const seatsPrint = getFieldMeta('seatsPrint', this.item);
      return seatsPrint ? true : false;
    },
    itemTicket () {
      const seatsPrint = getFieldMeta('seatsPrint', this.item);
      const vectorSeats = seatsPrint.split('-');
      const asientoTitle = vectorSeats[vectorSeats.length - 1];
      const filaTitle = vectorSeats[vectorSeats.length - 2];
      const sectorTitle = vectorSeats[vectorSeats.length - 3];
      let boxTitle = '';
      if (vectorSeats.length > 3) {
        boxTitle = vectorSeats[vectorSeats.length - 4];
      }

      const vector = this.item.position.split('-');
      const asiento = vector[vector.length - 1];
      const fila = vector[vector.length - 2];
      const sector = vector[vector.length - 3];
      let box = ''
      if (vector.length > 3) {
        box = vector[vector.length - 4];
      }

      const aux = `${sectorTitle}: ${sector} - ${filaTitle}: ${fila} - ${asientoTitle}: ${asiento}`;
      const result = box && boxTitle
        ? `${boxTitle}: ${box} - ${aux}`
        : aux;
      return {
        value: result,
        sectorTitle,
        filaTitle,
        asientoTitle,
        boxTitle,
        box
      }
    },
  },
  methods:{
    getFormatMonth(date) {
      const months = [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
      ]
      let month = new Date(date);
      let monthFormat = month.getMonth();
      return months[monthFormat];
    },
  }
}
</script>

<style scoped>
body {
  margin: 0;
  font-family: 'Poppins', sans-serif;
}
.loadergif {
  height: 100px;
}
.loading {
  background: #f2f2f2;
  height: calc(100vh - 50px);
  position: absolute;
  width: 100%;
  z-index: 2;
  text-align: center;
  padding-top: 100px;
}
.loading > span {
  font-size: 2em;
  display: block;
  font-weight: bold;
  padding-top: 20px;
}
.hide-printable {
  display: none !important;
}

.show-printable {
  display: unset !important;
}

.hidden {
  visibility: hidden;
}

/* //RESEND EMAIL */
.modal-resend {
  background: rgba(0, 0, 0, 0.6) !important;
  position:relative;
  z-index: 30;
  height: 100vh;
  width:100wv;
}
#resendModal{
  background: rgba(0, 0, 0, 0.6) !important;
  position:relative;
  z-index:30;
  height: 100vh;
  width:100%;
  display: flex;
  padding-top: 30px;
  justify-content:center;
}
.modal-dialog{
  border-radius: 16px;
  width: 520px;
  height:280px;
  background-color: #FFFFFF;
}
.modal-content{
  height: 100%;
}
.modal-header{
  display: flex;
  justify-content: flex-end;
  padding: 12px;
  background-color: #6ABDA6;
  border-radius: 16px 16px 0 0;
}
.modal-body{
  padding: 5px 20px;
}
.form-control{
  width: 100%;
  padding: 7px;
  /* margin: 0px; */
  height: 22px;
  border-radius: 5px;
  border: 1px solid;
}
.f-ticket-vs__head {
  text-transform: uppercase;
  font-size: 11px;
  margin-bottom: 2px;
}
.f-ticket-vs__body {
  display: flex;
  align-items: center;
  padding: 6px 2px;
  border-top: 3px solid #000;
  border-bottom: 3px solid #000;
}
.f-ticket-vs__vs {
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.f-ticket-activityLogo {
  display: inherit;
}
.f-ticket-vs__vs b {
  padding: 7px;
  font-size: 140%;
}

.ft-body-sector {
  display: table;
  max-width: 55%;
  width: 100%;
}
.ft-body-sector > div {
  /* width: 80px; */
  display: flex;
  justify-content: space-between;
  padding-bottom: 3px;
  margin-bottom: 3px;
  border-bottom: 1px solid;
}

.f-ticket {
  font-family: sans-serif;
  margin: 0px 25px 20px 25px;
  width: 795px;
  height: 305px;
  background: #fff;
  border-radius: 10px;
  display: flex;
  position: relative;
  box-shadow: 0 1px 5px rgba(0,0,0, 0.2) !important;
}
.f-ticket__decor {
  /*content: "";*/
  position: absolute;
  top: 10px;
  left: 190px;
  width: 505px;
  height: 285px;
  background: rgba(0, 0, 0, 0.1);
}
.f-ticket:before {
  content: "";
  position: absolute;
  top: 15px;
  left: 160px;
  width: 405px;
  height: 5px;
  background: red;
  z-index: 1;
  opacity: 0.8;
}
/* .f-ticket:after {
  content: "";
  position: absolute;
  top: 10px;
  left: 195px;
  width: 531px;
  height: 285px;
  background: rgba(0, 0, 0, 0.1);
} */
.f-ticket * {
  box-sizing: border-box;
}
.f-ticket .ft-upper {
  text-transform: uppercase;
}
.f-ticket__qr {
  width: 180px;
  flex-shrink: 0;
  padding: 10px;
  border-right: 5px dotted #c4c4c4;
}
.f-ticket__qr_imgs {
  text-align: center;
  padding: 3px 0;
}
.f-ticket__qr_qr {
  position: relative;
  padding: 0 8px 8px;
}
.f-ticket__qr_qr p{
  margin-top: -3px;
  margin-bottom: 0;
}
.f-ticket__qr_qr span {
  font-size: 12px;
  display: block;
  width: 0;
  position: absolute;
  top: 35%;
  bottom: 35%;
  right: 0;
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  -webkit-transform: rotate(-90deg) translateY(15px);
  transform: rotate(-90deg) translateY(15px);
}
.f-ticket__qr_title {
  text-transform: uppercase;
  font-size: 12px;
  line-height: 1.1;
  margin-bottom: 10px;
  margin-top: -3px;
  height: 25px;
  overflow: hidden;
  text-align: center;
}
.f-ticket__qr_vs {
  text-transform: uppercase;
  font-size: 8px;
  line-height: 1.2;
}
.f-ticket__qr_vs strong {
  display: block;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 2px;
  text-align: center;
}
.f-ticket__qr_tribuna {
  margin-top: 3px;
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  font-weight: 700;
}
.f-ticket__qr_tribuna .tline {
  width: 50%;
  padding-left: 5px;
  border-left: 1px solid #000;
}
.f-ticket__qr_tribuna > div {
  padding: 2px 0;
  width: 70%;
}
.f-ticket__qr_tribuna small {
  display: block;
  font-weight: 600;
}
.f-ticket__qr_tribuna .tribune {
  text-transform:uppercase;
  font-weight:normal;
  font-size: 8px;
}
.f-ticket__qr_sector {
  font-size: 11px;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #000;
}
.f-ticket__qr_info {
  font-size: 7.5px;
  text-align: justify;
  margin-top: 5px;
  position: absolute;
  bottom: 10px;
  width: 156px;
}
.f-ticket__body {
  flex-shrink: 0;
  width: 400px;
  border-right: 5px dotted #c4c4c4;
  position: relative;
  z-index: 9;
}
.f-ticket__body_ruc {
  text-transform: uppercase;
  font-weight: 900;
  font-size: 9px;
  display: block;
  width: 290px;
  position: absolute;
  left: -1px;
  bottom: 9px;
  line-height: 1.2;
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  -webkit-transform: rotate(-90deg) translateY(25px);
  transform: rotate(-90deg) translateY(25px);
}
.f-ticket__body_sure {
  position: absolute;
  bottom: 10px;
  left: 40px;
  font-size: 9px;
  font-weight: 500;
}
.f-ticket__body_content {
  padding: 28px 20px 20px 40px;
}
.f-ticket__body_head {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
}
.f-ticket__body_stadium {
  text-transform: uppercase;
}
.f-ticket__body_stadium b {
  display: block;
}
.f-ticket__body_date {
  text-align: right;
}
.f-ticket__body_vs {
  margin-top: 10px;
}
.f-ticket__body_tribune {
  font-size: 12px;
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}
.f-ticket__body_tribune b {
  text-transform: uppercase;
}
.f-ticket__body_logos {
  margin-top: 8px;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  left: 40px;
  right: 20px;
  bottom: 16px;
}
.f-ticket__body_logos .ft-jn {
  position: relative;
  right: -7px;
}
.f-ticket__info {
  flex-shrink: 0;
  position: relative;
  width: 110px;
  border-right: 5px dotted #c5c5c5;
  position: relative;
  z-index: 9;
}
.f-ticket__info_body {
  width: 305px;
  overflow: hidden;
  height: 100px;
  padding: 5px 20px;
  position: absolute;
  bottom: 0;
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  -webkit-transform: rotate(-90deg) translateY(100px);
  transform: rotate(-90deg) translateY(100px);
}
.f-ticket__info_footer {
  line-height: 1.2;
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.f-ticket__info_stadium {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 11px;
}
.f-ticket__info_stadium span {
  font-weight: 400;
  display: block;
  font-size: 9px;
}
.f-ticket__info_price {
  font-size: 18px;
  font-weight: 600;
}
.f-ticket__info_price small {
  font-weight: 400;
  font-size: 12px;
  display: block;
}
.f-ticket__info_tribuna {
  display: flex;
  justify-content: space-between;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.1;
}
.f-ticket__info_tribuna > div {
  padding: 3px 0;
}
.f-ticket__info_tribuna .tribunaLg {
  /* font-size: 110%; */
}
.f-ticket__barcode {
  flex-shrink: 0;
  position: relative;
  width: 90px;
}
.f-ticket__barcode_body {
  width: 305px;
  overflow: hidden;
  height: 100px;
  padding: 16px 20px;
  position: absolute;
  bottom: 0;
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  -webkit-transform: rotate(-90deg) translateY(100px);
  transform: rotate(-90deg) translateY(100px);
}
.f-ticket__barcode_head {
  font-size: 10px;
  display: flex;
  justify-content: space-between;
}
.f-ticket__barcode_data {
  font-weight: 600;
  text-transform: uppercase;
}
.f-ticket__barcode_price {
  font-weight: 600;
  font-size: 13px;
  line-height: 1.1;
}
.f-ticket__barcode_price small {
  font-weight: 400;
  display: block;
}
.f-ticket__barcode_footer {
  margin-top: 5px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.1;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.f-ticket__barcode_footer small {
  font-weight: 400;
  display: block;
  font-size: .9em;
}
.f-voucher {
  font-family: 'Arial';
  font-size: 14px;
  width: 500px;
  margin: 0 auto;
  position: relative;
  padding: 10px;
  border: 1px solid #000;
  margin-top: 20px;
  margin-bottom: 20px;
  flex-shrink: 0;
  page-break-after: always;
}
.f-voucher h2 {
  font-size: 16px;
  text-align: center;
  font-weight: bold;
}
.f-voucher table.items {
  border-bottom: 1px dashed #000;
}
.f-voucher table.items th {
  border-bottom: 1px solid #000;
}
.f-voucher table.items tr {
  height: 30px;
}
.f-voucher-qr {
  margin: 0 auto;
  width: 140px;
  margin-top: 30px;
  margin-bottom: 30px;
}
/*QUOTES*/
.jn-quotes{
  display: flex;
  justify-content: center;
  font-family: 'Poppins', sans-serif;
  width: 50%;
}
.jn-content-quotes{
  width: 480px;
}
.jn-option{
  margin-top: 15px;
}
.jn-option-detail{
  border-radius: 8px;
  border: 1px solid #BCC8D9;
  background-color: #fff;
}
.jn-option-detail:hover{
  border: 1px solid #1DC0C0;
}
.jn-option-ready{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 55px;
  background-color: rgba(188, 200, 217, 0.521);
  position: absolute;
  left: 0;
}
.jn-pay{
  height: 20px;
  background-color: #BCC8D9;
  color: #FFF;
  width: 100px;
  border-radius: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.jn-prepay{
  height: 20px;
  background-color: #31E8C2;
  color: #FFF;
  width: 100px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}
.jn-option-quotes {
  border: 1px solid #BCC8D9;
  border-radius: 4px;
  padding: 0px 10px;
  margin-bottom: 5px;
  height: 55px;
  display: flex;
  align-items: center;
  position: relative;
}
.jn-option-quotes-total {
  border: 1px solid #31E8C2;
  background-color: #E4FBFB;
  font-weight: bold;
  border-radius: 4px;
  padding: 5px 15px;
  margin: 15px 0px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.jn-option-quotes:hover {
  border: 1px solid #1DC0C0;
  /* color: #1DC0C0; */
  /* background-color: #32A481; */
}
.jn-option-quotes-item{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 5px;
  font-weight: 600;
  cursor: pointer;
}
.ju-nd-title {
  font-weight: bold;
  font-size: 16px;
  color: #000;
}
.ju-nd-badge{
  background-color:#FDA623;
  margin-left: 10px;
  border-radius: 15px;
  height: 15px;
  width: 35px;
  font-size: 0.75em;
  padding: 4px 8px;
}
.jn-option-btn {
  background-color: #E4FBFB;
  border-radius: 4px;
  border: 1px solid #E4FBFB;
  color: #1DC0C0;
  margin: 20px 0px;
}
.jn-option-btn:focus {
  background-color: #E4FBFB;
  border-radius: 4px;
  border: 1px solid #E4FBFB;
  color: #1DC0C0;
  margin: 20px 0px;
}
.jn-buy-button {
  background-color: #42a692;
  color: #fff;
  /* min-width: 230px; */
  border-radius: 6px;
  font-family: arial;
  padding: 6px 25px;
  cursor: pointer;
}
.jn-buy-button:hover {
  color: #fff;
}
/* Effects */
.ju-waves {
  position:relative;
  overflow:hidden;
  transform:translate3d(0,0,0)
}
.ju-waves:after {
  content:"";
  display:block;
  position:absolute;
  width:100%;
  height:100%;
  top:0;
  left:0;
  pointer-events:none;
  background-image:radial-gradient(circle,#FFF 10%,transparent 10.01%);
  background-repeat:no-repeat;
  background-position:50%;
  transform:scale(10,10);
  opacity:0;
  transition:transform .5s,opacity 1s
}
.ju-waves:active:after {
  transform:scale(0,0);
  opacity:.2;
  transition:0s
}
/*FOOTER*/
.buyer {
  position: relative;
  overflow: hidden;
  font-size: 16px;
  line-height: 26px;
  background: white;
  border-radius: 10px;
  padding: 15px;
  margin: 25px;
  border: 1px solid #eee;
}
.col-xs-12{
  width: 100%;
  float: left;
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}
.col-md-6{
  width: 50%;
  float: left;
  position: relative;
  min-height: 1px;
}
/*BUTTON */

.btn-round{
  border-color: #42a692;
  border-radius: 50px !important;
  border: 1px solid #fff;
  font-size: 1em;
}
.space-detail {
  margin-left: 35px;
}
.content-detail {
  padding: 0px 30px;
  margin: 15px 0px;
  /* display: flex;
  justify-content:center; */
}
.break-page {
  page-break-after: always;
}
.table-detail{
  width: 320px;
}
/* //container-quotes */
.container-quotes{
  /* height: 100vh; */
  border: 1px solid red;
  padding: 15px;
  /* margin: 20px; */
}
.header-quotes{
  margin: 20px;
  height: 60px;
  padding-left: 20px;
  border-radius: 10px;
  background: #EFEFEF;
  color: #333333;
  font-weight: bold;
  display: flex;
  align-items:center;
  font-size: 1.5em;
}
.body-quotes{
  display: flex;
  margin:20px;
  /* width: 100vw; */
}
.detail-quotes{
  padding: 20px;
  width: 50%;
}
.detail-info{
  padding: 0px 0px 10px 10px;
}
.detail-info > label {
  font-weight: bold;
  font-size: 1em;
}
/* //contianer */
.container{
  height: 100vh;
  width: 100%;
}
.navbar {
  height:50px;
  color: #FFFFFF;
  padding: 10px;
  background-color: #19161A;
  display:flex;
  align-items:center;
}
.container-ticket{
  border-left: 4px solid #42a692;
  margin: 0px 10px;
}
.content {
  background-color: #F9F9F9;
  min-height: calc(100vh - 80px);
  /* padding: 0px 20px; */
}
.ticket-title{
  display: flex;
  justify-content: space-between;
  align-items:center;
  margin: 0px 30px;
}
.ticket-title span{
  font-size: 1.5em;
  font-weight: bold;
}
/* .modal-dialog-centered {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
    min-height: calc(100% - 1rem);
} */
@media print {
  .no-print{
    display: none;
  }
  .container-ticket{
    border:none;
  }
}
@media  screen and (max-width: 480px){
  .content{
    padding: 2px;
  }
  .header-quotes{
    margin:10px
  }
  .body-quotes{
    display: flex;
    flex-wrap:wrap;
    margin: 10px;
  }
  .jn-quotes{
    width: 100%;
  }
  .detail-quotes{
    width: 100%;
    padding: 10px;
  }
  .detail-info{
    font-size: 0.9em;
    text-transform: uppercase;
  }
  /* //TICKET */
  .hidden-bar{
    border: none;
    margin:0px;
    background-color: red;
  }
  .container-ticket{
    border:none;
  }
  .content-detail{
    padding: 0px 10px;
  }
  .content-detail>.table-detail{
    width: 500px;
  }
  .content-detail>.table-detail h5{
    margin-bottom:5px;
  }
  .content-detail>.table-detail .row{
    font-size: 0.75em;
  }
  .f-ticket{
    margin: 0px 10px;
  }
  .ticket-title{
    margin: 0px 15px;
  }
}
</style>
